export const SNACKBAR_ERROR = 'snackbar/SNACKBAR_ERROR'
export const SNACKBAR_CLEAR = 'snackbar/SNACKBAR_CLEAR'
export const SNACKBAR_SUCCESS = 'snackbar/SNACKBAR_SUCCESS'
export const SNACKBAR_INFO = 'snackbar/SNACKBAR_INFO'
